import { render, staticRenderFns } from "./PaymentTypesSelectbox.vue?vue&type=template&id=568ccd8c"
import script from "./PaymentTypesSelectbox.vue?vue&type=script&lang=js"
export * from "./PaymentTypesSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports